<template>
  <div>
    <li v-for="(data, index) in dataArray" :index="index" :key="data.ref.extra_id + '-' + data.ref.date" :item="data" :class="{'extra-option': data.is_option}">
      <span v-if="data.is_included" class="included">option</span>
      <button v-if="!data.is_included" class="delete-btn" @click="removeExtra(data.ref)">x</button>
      <div class="image--wrapper">
        <img :src="`${data.picture}?w=240&h=220&crop-to-fit`">
      </div>
      <div class="infoproduct">
        <h6>{{data.name}}</h6>
        <p v-if="data.date" v-html="$t('shoppingCart.page.room.dates.date', `<span>${data.date}</span>`)"></p>
        <p v-if="data.count">x <strong>{{data.count}} {{type}}</strong></p>
        <p v-else><strong>{{$t('extras.type.' + data.type)}}</strong></p>
        <div class="priceproduct" >{{data.price | decimalPrice}} €</div>
      </div>
    </li>
  </div>

</template>

<script>
  import moment from 'moment'
  import extraPriceMixin from '../../../components/mixins/extra-price.mixin';

  export default {
    props: {
      extra: {
        type: Object,
        required: true
      }
    },
    methods: {
      removeExtra(data) {
        this.$emit('remove', data);
      }
    },
    computed: {
      type () {
        if (!this.data || !this.data.type) {
          return '';
        }
        return this.$t('extras.type.' + this.data.type);
      },
      dataArray() {
        const results =  this.extra.dates.map(date => {
          let price = this.extra.extra.price.amount;
          if (['EACH', 'PERSON', 'NONE', 'HOUR', 'DAY'].indexOf(this.extra.extra.type) !== -1) {
            price *= date.count;
          }
          return {
            picture: this.extra.extra.picture,
            name: this.extra.extra.text.name,
            date: moment(date.date).format('ddd DD MMM'),
            count: date.count,
            is_option: this.extra.is_option,
            is_included: this.extra.is_option,
            type: this.extra.extra.type,
            price: price,
            ref: {
              extra_id: this.extra.extra.id,
              date: date.date,
              qte: date.count,
            }
          }
        });
        if (this.extra.extra.discount && this.extra.extra.discount.is_available) {
          if (this.extra.extra.discount.type === 'FIX') {
            results.push({
              picture: this.extra.extra.picture,
              name: this.extra.extra.text.name,
              date: null,
              count: null,
              type: 'REDUCTION',
              price: -this.extra.extra.discount.amount.amount
            });
          } else if (this.extra.extra.discount.type === 'PERCENT') {
            const price = results.reduce((p,n) => (p+n.price), 0);
            results.push({
              picture: this.extra.extra.picture,
              name: this.extra.extra.text.name,
              date: null,
              count: null,
              type: 'REDUCTION',
              price: -(price * this.extra.extra.discount.amount.amount /100)
            });
          }
        }
        return results;
      }
    },
    name: "right-extra"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/tunnel/step3/right-extra.vue